import { React, useState, useEffect } from "react";
import {
    Button,
    Link,
    Grid,
    Typography,
    useMediaQuery
} from "@mui/material";

function ConvertToLink(props) {
    const txt = props.toString();
    if (props.toString().includes("https")) {
        const firstIndex = txt.indexOf("https"); //find link start 
        const linkEnd = txt.indexOf(" ", firstIndex) //find the end of link
        const firstTextSection = txt.slice(0, firstIndex)
        const linkSection = txt.slice(firstIndex, linkEnd)
        const secondSection = txt.slice(linkEnd)
        let textArr = [firstTextSection, linkSection, secondSection];
        let indexOfSlash = txt.lastIndexOf('/');
        let stormId = txt.substring(indexOfSlash + 1);
        return (
            <div >
                <a href={props} target="_blank" rel="noreferrer">{stormId}</a>
            </div>
        )
    }
    else {
        return (
            <p>{props}</p>
        )
    }
}

const ReadMore = ({ body, id, maxLength, index }) => {
    const [readMore, setReadMore] = useState(false);
    const isMobile = useMediaQuery("(max-width:768px)");
    const isDesktop = !isMobile;
    let fontSize = "8px";
    let paddingBtoom = "0px";

    return (
        <div>
            {body.length > maxLength && !body.startsWith("https") ?
                <div
                    key={id}
                    style={{
                        //  marginRight: "80px",
                        // width: "80px"
                        // display: 'flex',
                        // alignItems: 'center'
                    }}>
                    <Typography paddingBottom={paddingBtoom} variant={isMobile ? "caption" : fontSize}>
                        {readMore ? body : `${body.substring(0, index)}...`}
                    </Typography>

                    <Button
                        sx={{
                            // width: "86px",
                            fontSize: isMobile ? fontSize : ""
                        }}
                        onClick={() => setReadMore(!readMore)}>
                        <Typography paddingBottom={paddingBtoom} variant={isMobile ? "caption" : fontSize}>
                            {readMore ? "show less" : "  read more"}
                        </Typography>
                    </Button>
                </div>
                :
                <>
                    <Typography paddingBottom={paddingBtoom} variant={isMobile ? "caption" : fontSize}>
                        {ConvertToLink(body)}
                    </Typography>
                </>
            }
        </div>
    );
};

export default ReadMore;